<template>
  	<FlexAddPinValidity />
</template>

<script>

// @ is an alias to /src
import FlexAddPinValidity from "@/components/Flex/AddPinValidity.vue";

export default {
  name: "FlexAddPinValidityView",
  components: {
    FlexAddPinValidity,
  },
};
</script>
